export const shareViaEmail = (
  title: string,
  link: string | undefined,
  description: string,
  intro: string,
  outro: string,
  subject: string,
) => {
  const introText = intro;
  const outroText = outro;
  const subjectText = subject;

  const encodedTitle = encodeURIComponent(title);
  const encodedLink = encodeURIComponent(link ?? '');
  const encodedContent = encodeURIComponent(description);

  const mailto = `mailto:?body=${introText}%0D%0A%0D%0A${encodedTitle}%0D%0A${
    encodedLink ? `${encodedLink}%0D%0A` : ''
  }${encodedContent}%0D%0A%0D%0A${outroText},&subject=${subjectText}`;

  window.open(mailto, '_blank', 'noopener, noreferrer');
};
